import { CommonModule } from '@angular/common';
import { Component, effect, input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { firstValueFrom } from 'rxjs';
import { DocumentStatus } from 'src/app/leads/interface-data/data';
import { documentServices } from 'src/app/services/document.service';
import { environment } from 'src/environments/environment';
import { RejectReasonDialogComponent } from './rejectComponent.ts/reject-reason-dialog.component';
import { DialogComponent } from 'src/app/shared/dialog/confirm.dialog';
import { MatIcon } from '@angular/material/icon';
import { TruncatePipe } from 'src/app/pipe/truncate.pipe';
import { Router } from '@angular/router';
import { ImageSectionComponent } from 'src/app/portal/documents/show-file';
import { applicationType, statusCampain } from 'src/app/admissions/interface';
import { RemoveIdSuffixPipe } from 'src/app/pipe/remove-id';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { ClipboardModule,Clipboard } from '@angular/cdk/clipboard';
import { NotificationsService } from 'src/app/services/notifications/notifications.service';
import { tabsComunicationService } from '../../signal-tabs-communication';
import { userDataService } from 'src/app/services/userDataService';
import { Status } from 'src/app/helper/enum';
import { DocumentType } from 'src/app/admissions/interface'
import { applicationService } from 'src/app/services/applications.service';
import { EditMessageDialogComponent, EditMessageDialogData, EditMessageDialogResult } from './rejectComponent.ts/edit-message-dialog.component';
import { CommunicationService } from '../../signal-lead.serice';


@Component({
  selector: 'app-documents',
  standalone: true,
  imports: [CommonModule, MatTooltip,MatIcon,TruncatePipe,ImageSectionComponent,RemoveIdSuffixPipe,MatMenuModule,MatButtonModule,TruncatePipe,ClipboardModule],
  providers:[RemoveIdSuffixPipe],
  templateUrl: './documents.component.html',
  styleUrl: './documents.component.scss'
})
export class DocumentsComponent implements OnInit {
  data = input<any>();
  params = input<any>();
  lead = input<any>();
  paramsChild: any;
  timelineData: any[] = [];
  total: number = 0;
  showLoad: boolean = true;
  documents: any[] = [];
  documnetStatus = DocumentStatus;
  lead_id:any;
  lead_applications:any[]=[]
  currentLead:any
  linkApplication:any;
  linkFinancialAid:any;
  documentLink:any;
  has_missing_documents:boolean
  currentUser:any;
  isEmailSync:boolean=false;
  invalid_sms:boolean=false;
  invalid_email:boolean=false
  isModal = input<boolean>(false);

  missingApplications: applicationType[] = [];

  constructor(
    private documentService: documentServices,
    private dialog: MatDialog,
    private router: Router, 
    private clipboard: Clipboard,
    private showsnack:NotificationsService,
    private tabsService:tabsComunicationService,
    private userDataService:userDataService,
    private readableNamePipe: RemoveIdSuffixPipe,
    private applicationService:applicationService,
    private communicationService: CommunicationService,
  ) { 
    effect(() => {
      const newLead = this.lead();
      if (newLead) {
        this.currentLead = newLead
        this.invalid_sms = this.currentLead?.invalid_sms
        this.invalid_email = this.currentLead?.invalid_email
        if(this.currentLead.status==Status.WON){
          const findIndex = this.documents.findIndex(x=>x.document.type=='post_enrollment' && (x.status == statusCampain.DRAFT || x.status == 'REJECTED'))
          this.has_missing_documents = findIndex !== -1 ? true:false
        }else{
          this.has_missing_documents = this.currentLead?.has_missing_documents
        }
      }
    });
   }

  async ngOnInit() {
    this.lead_id = this.lead().id
    this.lead_applications = this.lead()?.lead_applications
    this.currentLead = this.lead()
    this.documents = this.data()?.data;
    if(this.currentLead.status==Status.WON){
      const findIndex = this.documents.findIndex(x=>x.document.type=='post_enrollment' && (x.status == statusCampain.DRAFT || x.status == 'REJECTED'))
      this.has_missing_documents = findIndex !== -1 ? true:false
    }else{
      this.has_missing_documents = this.currentLead?.has_missing_documents
    }
    this.currentUser = await this.userDataService.getUserData();
    // Build missingApplications from active company applications
    const activeTypes: string[] = (this.currentLead?.Company?.applications || [])
      .map(a => a.type)
      .filter(Boolean);

    this.missingApplications = [
      applicationType.lead_application,
      applicationType.financial_aid,
    ].filter(type => activeTypes.includes(type));

    // Remove already submitted ones
    this.lead_applications.forEach(x => {
      const appType = x.application.type;
      const index = this.missingApplications.indexOf(appType);
      if (index !== -1) {
        this.missingApplications.splice(index, 1);
      }
    });
    this.lead().applicationToken.forEach(x=>{
       if(x.type_token==applicationType.financial_aid){
        this.linkFinancialAid =  `${environment.uiUrl}/financial-aid/false/${this.lead_id}?token=${x.token}`
       }else if (x.type_token==applicationType.lead_application){
        this.linkApplication = `${environment.uiUrl}/application/false/${this.lead_id}?token=${x.token}`
       }else if (x.type_token=='documents'){
        this.documentLink = `${environment.uiUrl}/documents-student/${this.lead_id}?token=${x.token}`
       }
    })

    if (this.currentUser) {
      this.isEmailSync = !!this.currentUser.GoogleTokens.find(x => x.service === 'GMAIL');
    }
  }
  

  async approveDocument(document: any,itsSwitch=false) {
    const obj = {
      lead_document_id: document.id,
      response: DocumentStatus.APPROVED,
      statusOfLeAD:this.currentLead.status,
      itsSwitch
    }
    const {data,has_missing_documents} = await firstValueFrom(this.documentService.put(obj, document.id, 'lead_document'))

    this.has_missing_documents = has_missing_documents;

    // if(!has_missing_documents){
    //   delete this.documentLink
    // }
    
    if (data) {
      const updatedDocument = this.documents.find(doc => doc.id === document.id);
      if (updatedDocument) {
        updatedDocument.status = DocumentStatus.APPROVED;
      }
    }
  }

  async reRejectDocument(document:any){
    const header = 'Confirm Reject';
    const content = 'Are you sure you want to switch to reject this document?';
  
    const response = await this.callDialog(header, content);
    if(response){
      await this.rejectDocument(document,true)
    }
  }

  async reApproveDocument(document){
    const header = 'Confirm Approval';
    const content = 'Are you sure you want to switch to approve this document?';
  
    const response = await this.callDialog(header, content);

    if(response){
      await this.approveDocument(document,true)
    }

  }

  async rejectDocument(document: any,itsSwitch:boolean) {
    const dialogRef = this.dialog.open(RejectReasonDialogComponent, {
      width: 'auto',
      data: { reason: '' }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        const data = {
          lead_document_id: document.id,
          response: DocumentStatus.REJECTED,
          reason: result.reason,// Include the rejection reason
          statusOfLeAD:this.currentLead.status,
          itsSwitch,
        }
        const response = await firstValueFrom(this.documentService.put(data, document.id, 'lead_document'))
        if (response) {
          const updatedDocument = this.documents.find(doc => doc.id === document.id);
          this.has_missing_documents=true
          if (updatedDocument) {
            updatedDocument.status = DocumentStatus.REJECTED;
            updatedDocument.reason = result.reason; // Optionally store the reason in the document object
          }
        }
      }
    });
  }

  viewApplication(event){
    const isAdmin = true;
    const leadId = this.lead_id;
    event.application.type=='lead_application'?  
      window.open(`/application/${isAdmin}/${leadId}`, '_blank'):
        window.open(`/financial-aid/${isAdmin}/${leadId}`, '_blank')
  }

  openLink(event){
    window.open(event, '_blank')
  }

  // 3. Replace the existing generate method with this updated version:
async generate(type: 'sms' | 'email' | 'link', type_token: string) {
  let obj: any = { type, lead_id: this.lead_id, type_token };

  // Get existing link or we'll need to generate one first for SMS/email
  let existingLink = '';
  if (type_token === applicationType.lead_application) {
    existingLink = this.linkApplication || '';
  } else if (type_token === applicationType.financial_aid) {
    existingLink = this.linkFinancialAid || '';
  } else if (type_token === 'documents') {
    existingLink = this.documentLink || '';
  }

  // For SMS or Email, open the edit dialog
  if (type === 'sms' || type === 'email') {
    // If no link exists yet, generate one first (just the link)
    if (!existingLink) {
      try {
        const linkResponse: any = await firstValueFrom(
          this.documentService.generateLink({ type: 'link', lead_id: this.lead_id, type_token })
        );
        existingLink = linkResponse.link;
        
        // Store the generated link
        if (type_token === applicationType.lead_application) {
          this.linkApplication = existingLink;
        } else if (type_token === applicationType.financial_aid) {
          this.linkFinancialAid = existingLink;
        } else if (type_token === 'documents') {
          this.documentLink = existingLink;
        }
      } catch (err: any) {
        console.error('Generate link error:', err);
        const errorMessage = this.extractErrorMessage(err);
        this.showsnack.showClientError(errorMessage);
        return;
      }
    }

    // Get default template
    const defaultTemplate = this.getDefaultTemplate(type, type_token, existingLink);

    // Open edit message dialog
    const dialogRef = this.dialog.open(EditMessageDialogComponent, {
      width: type === 'email' ? '600px' : '500px',
      data: {
        type,
        typeToken: type_token,
        defaultMessage: defaultTemplate.message,
        defaultSubject: defaultTemplate.subject,
        link: existingLink
      } as EditMessageDialogData
    });

    const result: EditMessageDialogResult = await dialogRef.afterClosed().toPromise();
    
    if (!result || !result.confirmed) {
      return; // User cancelled
    }

    // Build the request object with custom message
    obj.link = existingLink;
    obj.customMessage = result.message;
    if (type === 'email') {
      obj.customSubject = result.subject;
    }
    obj.isEmailSync = this.isEmailSync;
    obj.fromPhoneNumber = this.currentUser?.Company?.phoneNumber;
    obj.toPhoneNumber = this.currentLead.prefix + this.currentLead.phoneNumber;
    obj.from = this.isEmailSync ? this.currentUser.email : this.currentUser.email_company;
    obj.to = this.currentLead.email;
  }

  try {
    const response: any = await firstValueFrom(this.documentService.generateLink(obj));

    if (type_token === applicationType.lead_application) {
      this.linkApplication = response.link;
    } else if (type_token === applicationType.financial_aid) {
      this.linkFinancialAid = response.link;
    } else if (type_token === 'documents') {
      this.documentLink = response.link;
    }

    const filteredTypeToken = this.getDisplayName(type_token);

    if (type === 'sms' || type === 'email') {
      this.showsnack.showNonErrorSnackBar(`The ${filteredTypeToken} link has been successfully sent via ${type}.`, 2000);
      
      // Only update tabs if message has actual data
      if (response.message && Object.keys(response.message).length > 0) {
        this.tabsService.updateData({
          type: `document-${type}`,
          obj: { data: { message: response.message } },
        });

           // ✅ ADD: Same signal that email-sms uses
      this.communicationService.updateData({
        type: 'sms-email',
        obj: { location: 'sms-email', update: true },
      });
      }
    } else {
      this.showsnack.showNonErrorSnackBar(`The ${filteredTypeToken} link has been created successfully.`, 2000);
    }
  } catch (err: any) {
    console.error('Send message error:', err);
    const errorMessage = this.extractErrorMessage(err);
    this.showsnack.showClientError(errorMessage);
  }
}

// 4. Add this helper method to extract error messages safely:
private extractErrorMessage(err: any): string {
  // Handle null/undefined
  if (!err) {
    return 'An unexpected error occurred';
  }

  // If it's already a string, return it
  if (typeof err === 'string') {
    return err;
  }

  // Try various error structures
  // NestJS/HTTP error: err.error.message
  if (err?.error?.message && typeof err.error.message === 'string') {
    return err.error.message;
  }

  // Standard Error object: err.message
  if (err?.message && typeof err.message === 'string') {
    return err.message;
  }

  // NestJS might return error as string in err.error
  if (err?.error && typeof err.error === 'string') {
    return err.error;
  }

  // Some APIs return statusText
  if (err?.statusText && typeof err.statusText === 'string') {
    return err.statusText;
  }

  // Last resort - try to stringify but return fallback if it's [object Object]
  try {
    const stringified = String(err);
    if (stringified !== '[object Object]') {
      return stringified;
    }
  } catch {
    // Ignore stringify errors
  }

  return 'An error occurred. Please try again.';
}

  copyText(link){
    if (link) {
      this.clipboard.copy(link);
      this.showsnack.showNonErrorSnackBar('Link copied',1000)
    }
  }

   callDialog(header: string, content: string) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          header,
          content,
        },
        width: '500px', // Optional: customize dialog size
      });
  
      return dialogRef.afterClosed().toPromise();
    }

    onFileSelected(event: any, document: any) {
      const file: File = event.target.files[0];
      if (file) {
        // Handle the file upload here
        this.uploadFile(file, document);
      }
    }
  
    async uploadFile(file: File, document: any) {
      const formData = new FormData();

      const obj:any = {id:document.id,isReps:true,lead_id:this.lead_id,preValue:document.status}

      formData.append('file',file)
      formData.append('data',JSON.stringify(obj))

      const {response:uploadResponse,has_missing_documents}:any = await firstValueFrom(
        this.documentService.postDocument(formData)
      );

      // if(!has_missing_documents){
      //   this.documentLink=''
      //   this.has_missing_documents=has_missing_documents
      // }
  
      if (uploadResponse) {
        // Create a new array where the updated document is replaced by a new object
        this.documents = this.documents.map(doc =>
          doc.id === document.id
            ? uploadResponse
            : doc
        );
      }
    }

    async clearApplication(application: any) {
      const header = 'Confirm Application Removal';
      const content = `Are you sure you want to remove this ${this.getDisplayName(application.application.type)}? This will allow the student to re-upload.`;
      
      const response = await this.callDialog(header, content);
      if (response) {
        try {
          // Call your backend service to remove the application
          const result = await firstValueFrom(
            this.documentService.deleteApplication(application.id)
          );
          
          if (result) {
            const index = this.lead_applications.findIndex(app => app.id === application.id);
            if (index !== -1) {
              this.lead_applications.splice(index, 1);
            }
            
            // Add back to missingApplications if needed
            const appType = application.application.type;
            if (!this.missingApplications.includes(appType)) {
              this.missingApplications.push(appType);
            }
            
            
            this.showsnack.showNonErrorSnackBar(
              `${this.getDisplayName(appType)} has been cleared successfully.`,
              2000
            );
          }
        } catch (error) {
          this.showsnack.showClientError(
            error?.error?.message || 'Failed to clear application. Please try again.'
          );
        }
      }
    }

    async exportApplication(application: any) {
      try {
        this.showsnack.showNonErrorSnackBar('Generating PDF...', 1000);
        
        // Use the new dedicated method
        const blob = await firstValueFrom(
          this.applicationService.exportApplicationPdf(application.id)
        );
        
        // Create download link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const fileName = `${this.getDisplayName(application.application.type)}_${this.currentLead.fullName}_${new Date().getTime()}.pdf`;
        link.download = fileName;
        
        link.click();
        window.URL.revokeObjectURL(url);
        
        this.showsnack.showNonErrorSnackBar('PDF downloaded successfully', 2000);
      } catch (error) {
        console.error('Error exporting application:', error);
        this.showsnack.showClientError('Failed to export application. Please try again.');
      }
    }


getApplicationDate(data: applicationType): string | null {
  if (!this.currentLead) return null;
  
  switch(data) {
    case applicationType.lead_application:
      return this.currentLead.enrollment_application_date;
    case applicationType.financial_aid:
      return this.currentLead.financial_aid_application_date;
    default:
      return null;
  }
}


// 2. Add this helper method to get default templates (matching backend):
private getDefaultTemplate(type: 'sms' | 'email', typeToken: string, link: string): { message: string; subject?: string } {
  const templates: Record<string, { sms: string; email: { subject: string; body: string } }> = {
    documents: {
      sms: `Hi there! Please check out this link for Documents: ${link}`,
      email: {
        subject: 'Your Documents Access Link',
        body: `
          <p>Dear User,</p>
          <p>We are excited to share your documents with you. Please click the link below to access them:</p>
          <p><a href="${link}" style="background-color: #3498db; color: white; padding: 10px 15px; text-decoration: none; border-radius: 5px;">Access Documents</a></p>
          <p>Thank you for choosing our services.</p>
          <p>Best regards,<br>Your Company Team</p>
        `,
      },
    },
    financial_aid: {
      sms: `Hi there! Please check out this link for Financial Aid: ${link}`,
      email: {
        subject: 'Your Financial Aid Application Link',
        body: `
          <p>Hello,</p>
          <p>We are pleased to assist you with your financial aid process. Click the button below to proceed with your application:</p>
          <p><a href="${link}" style="background-color: #27ae60; color: white; padding: 10px 15px; text-decoration: none; border-radius: 5px;">Apply for Financial Aid</a></p>
          <p>If you have any questions, feel free to reach out.</p>
          <p>Sincerely,<br>The Financial Aid Team</p>
        `,
      },
    },
    lead_application: {
      sms: `Hi there! Please check out this link for Admission Application: ${link}`,
      email: {
        subject: 'Your Admission Application is Ready',
        body: `
          <p>Hi there,</p>
          <p>Thank you for your interest! Your Admission Application is now available. Click the button below to view your application:</p>
          <p><a href="${link}" style="background-color: #e67e22; color: white; padding: 10px 15px; text-decoration: none; border-radius: 5px;">View Application</a></p>
          <p>We look forward to working with you.</p>
          <p>Warm regards,<br>The Team</p>
        `,
      },
    },
  };

  const template = templates[typeToken] || {
    sms: `Hi there! Please check out this link: ${link}`,
    email: {
      subject: 'Your Application Link',
      body: `
        <p>Hello,</p>
        <p>Please find your application link below:</p>
        <p><a href="${link}" style="background-color: #34495e; color: white; padding: 10px 15px; text-decoration: none; border-radius: 5px;">Access Link</a></p>
        <p>Thank you,<br>Your Company</p>
      `,
    },
  };

  if (type === 'sms') {
    return { message: template.sms };
  } else {
    return { message: template.email.body, subject: template.email.subject };
  }
}

getDisplayName(type: string): string {
  if (type === 'lead_application') return 'Admission Application';
  return this.readableNamePipe.transform(type);
}

}